import React from 'react'
import env from './../../../environments/environment'
import { autoLogin, getAgentAccessToHeadshot } from './../../../shared/utilities/getHeadshot.function'

function renderHeadshot(agent) {
  const { agentPic, agentName, agentId, agentScope, usertypeId, isConfQualified } = agent

  let badge = null
  if (agentScope === 'career_agent' && [90, 38, 93].includes(parseInt(usertypeId)))
    badge = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fbadge.sig-agent.png?alt=media`

  return (
    <div
      className={
        (agentId && getAgentAccessToHeadshot(agentId) ? 'profile-img-wrapper cursor-pointer' : 'profile-img-wrapper') +
        (isConfQualified ? ' qualified' : '')
      }
      onClick={() => {
        if (agentId && getAgentAccessToHeadshot(agentId)) autoLogin(agentId)
      }}
    >
      {badge ? (
        <div className='sig-agent-badge' alt='Signature Agent'>
          <img src={badge} />
        </div>
      ) : (
        <></>
      )}
      <img src={agentPic} alt={agentName} className='mx-auto d-block leaderboard-profile-img' />
    </div>
  )
}

function renderHeadshotWithName(agent) {
  const { agentPic, agentName, agentId, isConfQualified } = agent
  return (
    <div className='profile-container'>
      <div className='img-wrapper'>
        <div
          className={
            (agentId && getAgentAccessToHeadshot(agentId)
              ? 'profile-img-wrapper cursor-pointer'
              : 'profile-img-wrapper') + (isConfQualified ? ' qualified' : '')
          }
          onClick={() => {
            if (agentId && getAgentAccessToHeadshot(agentId)) autoLogin(agentId)
          }}
        >
          <img src={agentPic} alt={agentName} className='mx-auto d-block leaderboard-profile-img' />
        </div>
      </div>
      <div className='identity-wrapper'>
        <p className='text-center'>{agentName}</p>
        {isConfQualified ? <div className='qualified-label'>USABG Conf Qualifier</div> : null}
      </div>
    </div>
  )
}

export { renderHeadshot, renderHeadshotWithName }
